<div class="iframe-container">
    <iframe #jaivikIframe [src]="iframeUrl" (load)="onIframeLoad(jaivikIframe)" width="100%" height="100%"
        frameborder="0">
    </iframe>
</div>